import { FC, useEffect, useMemo } from 'react'

import { SubmitInspectionHeader } from './SubmitInspectionHeader'
import { SubmitInspectionForm } from './SubmitInspectionForm'
import { Application } from '../../../core/applications'
import { isPopulatedArray } from '../../../../components/helpers'

type Props = {
  appData: Application
  draftVars: Record<string, any>
  reviewId: number      
  doClose: Function        
}

const SubmitInspectionModal: FC<Props> = ({appData, reviewId, draftVars, doClose}) => {
  
  const { headerState, reviewDraftVars, reviewState } = useMemo(() => {
    const fallbackState = appData?.state ?? '';
    
    const defaultResult = {
      headerState: fallbackState,
      reviewDraftVars: {} as Record<string, any>,
      reviewState: '',
    };

    if (!appData || !reviewId || !isPopulatedArray(appData.applicationReviews)) {
      return defaultResult;
    }

    // 1. Single lookup for the target review
    const matchingReview = appData.applicationReviews.find(
      (review) => review.id === reviewId
    );

    if (!matchingReview) {
      return defaultResult;
    }

    // 2. Derive reviewState and appState
    const isInspectionProcess = appData.state === 'Inspection Process - Inspection';
    
    const computedReviewState = isInspectionProcess && matchingReview.state 
      ? matchingReview.state 
      : '';

    const computedAppState = isInspectionProcess && matchingReview.state
      ? matchingReview.state
      : fallbackState;

    // 3. Derive reviewDraftVars
    let parsedDraftVars: Record<string, any> = {};
    if (matchingReview.draft) {
      try {
        parsedDraftVars = JSON.parse(matchingReview.draft);
      } catch {
        /* Invalid JSON fallback to {} */
      }
    }

    return {
      headerState: computedAppState,
      reviewDraftVars: parsedDraftVars,
      reviewState: computedReviewState,
    };
  }, [appData, reviewId]);
  
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
  <>
  <div
    className='modal fade show d-block'
    id='kt_submit_inspection_modal'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >    
    <div className='modal-dialog modal-dialog-centered mw-550px'>    
      <div className='modal-content'>
        <SubmitInspectionHeader appState={headerState} doClose={doClose} />                
        <div className='modal-body scroll-y py-0 my-2 pb-4'>
          <SubmitInspectionForm 
            appData={appData}            
            reviewState={reviewState}
            reviewId={reviewId}
            draftVars={draftVars}    
            reviewDraftVars={reviewDraftVars} 
            doClose={doClose}                         
          />
        </div>                
      </div>            
    </div>            
  </div>    
  <div className='modal-backdrop fade show'></div>    
  </>
  )
}

export {SubmitInspectionModal}
